import { BaseEntity } from "yt-ng-framework";

export class StopaView extends BaseEntity{
    constructor(){
        super();
    };

    
    Datum:Date;
    Tarifa:string;
    Iznos:number;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Datum = new Date(input.Datum);
        this.Tarifa=input.Tarifa;
        this.Iznos=input.Iznos;
        return this;
    }

    Serialize(input:StopaView){
        return input;
    }

}